import React, { CSSProperties } from 'react'
import classNames from 'classnames'

interface IMoreButtonProps {
  onClick?(): void
  style?: CSSProperties
  color?: string
  activeColor?: string
  clkTeaParams?: string
  className?: string
}

export const MoreButton: React.FC<IMoreButtonProps> = ({
  children,
  onClick,
  style,
  color = '#606370',
  activeColor = '#1f2129',
  clkTeaParams,
  className,
}) => {
  return (
    <React.Fragment>
      <button
        type={'button'}
        className={classNames(
          'more-button tw-h-20 tw-text-14 tw-leading-20',
          className
        )}
        onClick={onClick}
        style={style}
        data-log-click={clkTeaParams}
      >
        {children}
        <i className={`DCD_Icon icon_PC-triangle tw-text-16 tw-align-bottom`} />
      </button>
      <style jsx>
        {`
          .more-button {
            color: ${color};
          }
          .more-button:hover {
            color: ${activeColor};
          }
        `}
      </style>
    </React.Fragment>
  )
}
